var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import i18n from "i18next";
import { initReactI18next } from "react-i18next";
import en from "./lng/en.json";
import hu from "./lng/hu.json";
export const initI18n = () => __awaiter(void 0, void 0, void 0, function* () {
    yield i18n.use(initReactI18next).init({
        ns: [
            "dashboard",
            "measures",
            "onboarding",
            "doctor",
            "preop",
            "pregnancy",
            "defaultMessages",
            "common",
        ],
        defaultNS: "common",
        resources: {
            en,
            hu,
        },
        fallbackLng: "hu",
        debug: true,
        interpolation: {
            escapeValue: false,
        },
    });
});
